module.exports = __webpack_public_path__ + "img/44.e31bc933.svg";